import checkOptionsFallback from './checkOptionsFallback';
import checkTargetLanguageValid from './checkTargetLanguageValid';
import getSupportedLanguages from '../services/getSupportedLanguages';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import setSupportedLanguageMap from '../actions/setSupportedLanguageMap';
import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import { getGuid } from 'owa-guid';
import store from '../store/store';

const initialRetryDelay: number = 15000;
let lastInitAttempt: number = 0;
let initRetryDelay: number = initialRetryDelay;

// This function initializes the translation store properties.
// It only updates the properties for the first call and
// any time user changes language (UserCulture in session settings)
// It returns 'true' when the store properties are updated.
export default async function initSupportedLanguages(): Promise<boolean> {
    const userCulture = getUserConfiguration().SessionSettings.UserCulture;
    const timeStamp = Date.now();

    // checks if feature flights are turned off, restore options to compatible values
    checkOptionsFallback();

    // this method is called on every message opened. Normally only the first time
    // it runs getSupportedLanguages as this is cached. In case it fails
    // initRetryDelay controls minimum time before we try again.
    if (
        userCulture !== store.localeOfSupportedLanguageMap &&
        (lastInitAttempt === 0 || timeStamp > lastInitAttempt + initRetryDelay)
    ) {
        let supportedLanguages = null;
        let correlationId = getGuid();
        const datapoint = new PerformanceDatapoint('InlineTranslationGetSupportedLanguages');
        try {
            supportedLanguages = await getSupportedLanguages(userCulture, correlationId);
            lastInitAttempt = 0;
            initRetryDelay = initialRetryDelay;
            datapoint.end();
        } catch (ex) {
            const error = new Error(
                '[InlineTranslation] getSupportedLanguages failed. Error:' +
                    ex +
                    ' | cid:' +
                    correlationId
            );

            // Double retry delay every attempt
            lastInitAttempt = timeStamp;
            initRetryDelay = 2 * initRetryDelay;
            datapoint.endWithError(DatapointStatus.ServerError, error);
            throw ex;
        }
        setSupportedLanguageMap(userCulture, supportedLanguages);
        checkTargetLanguageValid();
        return true;
    }
    return false;
}
